<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Manage Onboarding Presets</h4>
</div>
<br />
<br />

<div class="modal-body">
    @if (isLoading()) {
        <div class="text-center p-4">
            <p class="mt-2">Loading presets...</p>
        </div>
    } @else if (!hasPresets) {
        <div class="text-center p-4">
            <p class="text-muted">No presets found.</p>
        </div>
    } @else {
        <div class="preset-list">
            <!-- Header Row -->
            <app-layout-row class="preset-header-row first-child">
                <app-layout-column [width]="8">
                    <h6 class="preset-header-title">Existing Presets</h6>
                </app-layout-column>
                <app-layout-column [width]="4">
                    <h6 class="preset-header-title text-end"></h6>
                </app-layout-column>
            </app-layout-row>

            <!-- Data Rows -->
            @for (preset of presets(); track preset.Id) {
                <app-layout-row class="preset-data-row">
                    <app-layout-column [width]="8" class="preset-info-column first-child">
                        <div class="preset-name">{{ preset.Name }}</div> 
                    </app-layout-column>
                    <app-layout-column [width]="4" class="preset-actions-column last-child">
                        <div class="preset-actions">
                            <app-button 
                                tertiery
                                size="sm"
                                (click)="renamePreset(preset)"
                                title="Rename preset"><i class="dx-icon-edit"></i></app-button>
                            <app-button 
                                tertiery
                                size="sm"
                                (click)="deletePreset(preset)"
                                title="Delete preset"><i class="dx-icon-trash"></i></app-button>
                        </div>
                    </app-layout-column>
                </app-layout-row>
            }
        </div>
    }
</div>

<div class="modal-footer">
    <app-button 
        appButtonPrimary
        (click)="close()">
        Close
    </app-button>
</div>